<div class="max-lg:hidden">
  <p class="text-black mr-4 mt-2">دسته بندی اخبار</p>
  <div class="relative mt-10 flex justify-center items-center">
    <div class="absolute cursor-pointer right-0 search--icon">
      <i class="ie-search-page rotate-90"></i>
    </div>
    <label for="search-bar"></label>        
    <input
      type="text"
      type="text"
      name="search-bar"
      class="search-input search-sector"
      placeholder="جستجو یا انتخاب دسته بندی"
      [(ngModel)]="searchItem"
      aria-label="search-bar"
    />
    <div class="h-[2rem] flex justify-center" (click)="openList()">
      <i
        class="ie-icon openList open-tab"
        [ngClass]="isListOpen ? 'rotate-90deg' : ''"
      ></i>
    </div>
  </div>
  <div class="m-1 main-listSelector">
    <div
      class="justify-center bg-blue-400 m-2 mx-3 p-1.5 listField"
      *ngFor="let x of list"
      [ngClass]="x.isActive ? 'flex' : '!hidden'"
    >
      <span> {{ x.title }} </span>
      <i
        class="ie-icon close-cross cross-icon cursor-pointer"
        (click)="responsiveActive(x.value)"
      ></i>
    </div>
  </div>
  <div class="relative mt-10 flex justify-center items-center">
    <ul
      class="rounded-2xl shadow-md p-5 w-[20rem]"
      [ngClass]="isListOpen ? 'activate-tab' : 'deactive-tab'"
    >
      <li
        *ngFor="let item of list | filter : searchItem"
        class="hover:bg-[#FAFAFA] mb-3 cursor-pointer"
        (click)="responsiveActive(item.value, true)"
      >
        {{ item.title }}
      </li>
    </ul>
  </div>
</div>
<div class="lg:hidden">
  <div
    class="justify-center"
    style="display: flex; flex-wrap: wrap; max-width: 30rem"
  >
    <div
      class="flex justify-center py-2 symbol-card cursor-pointer"
      *ngFor="let item of list; last as isLast"
      [ngClass]="isLast && list.length % 2 != 0 ? 'w-full' : 'min-w-[45%]'"
    >
      <div
        class="p-2 responsiveField"
        [ngClass]="{ 'activated-tab': item.isActive }"
        (click)="responsiveActive(item.value)"
      >
        <span class="flex items-end text-xl font-medium">{{ item.title }}</span>
      </div>
    </div>
  </div>
</div>
